import { ButtonType, EpicIcons, TooltipPosition } from "@constellation-academy/epic-ui";
import { InputText } from "primereact/inputtext";
import { ChangeEvent, Suspense, useCallback, useDeferredValue, useState } from "react";
import { Button, ButtonVariant } from "@components/button";
import { useTranslation } from "@i18n/hooks";
import { SelectUserFieldTable } from "./parts/select-user-field-table/select-user-field-table.component";
import { wrapperClass } from "./select-user-field.styles";
import { type SelectUserFieldProps } from "./select-user-field.types";

export const SelectUserField = <T extends string | string[]>({
	updateField,
	fieldValue,
	accountId,
	isMultipleSelection = false,
}: SelectUserFieldProps<T>) => {
	const { t } = useTranslation("common");
	const [nameOrEmail, setNameOrEmail] = useState("");
	const deferredNameOrEmail = useDeferredValue(nameOrEmail);

	const handleClearFormOnClick = () => {
		setNameOrEmail("");
	};

	const handelNameOrEmailChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setNameOrEmail(e.target.value);
	}, []);

	return (
		<>
			<div className={wrapperClass}>
				<InputText
					value={nameOrEmail}
					onChange={handelNameOrEmailChange}
					placeholder={t("user.searchByNameOrEmail")}
					className="mr-2"
				/>
				<Button
					disabled={false}
					onClick={() => {}}
					type={ButtonType.Button}
					icon={EpicIcons.SEARCH}
					tooltip={t("user.searchTooltip")}
					position={TooltipPosition.Left}
				/>
				<Button
					disabled={false}
					type={ButtonType.Reset}
					variant={ButtonVariant.Error}
					onClick={handleClearFormOnClick}
					icon={EpicIcons.TIMES}
					tooltip={t("user.resetTooltip")}
					position={TooltipPosition.Left}
				/>
			</div>
			<Suspense fallback={<div>{t("app.loading")}</div>}>
				<SelectUserFieldTable<T>
					nameOrEmail={deferredNameOrEmail}
					accountId={accountId}
					fieldValue={fieldValue as T}
					updateField={updateField}
					isMultipleSelection={isMultipleSelection}
				/>
			</Suspense>
		</>
	);
};
